import React, { useEffect, useState } from 'react';
import { selectOneSetting, selectOverview } from '../../../../util/store/selectors';
import { useSelector } from "../../../../util/store/store";
import { IVessel } from "../../../../util/varibles/interface";
import { OverviewSetting } from "../../../../util/varibles/userSetting";
import { IVesselHeight } from "../Vessels";
import CurrentDay from "./CurrentDay";
import Day from "./Day";
import Week from "./Week";
import styles from "./style.module.scss";

const week = [0, 1, 2, 3, 4, 5, 6];

interface IProps {
    vesselHeight: IVesselHeight
    vessels: IVessel[]
}

const Weeks: React.FC<IProps> = ({ vesselHeight, vessels }) => {
    const weekPerPage = useSelector(selectOneSetting(OverviewSetting.WEEK_PER_PAGE));
    const weeks = useSelector(selectOverview.weeks);
    const style: any = { '--week-per-screen': weekPerPage };
    const [days, setDays] = useState(<div />);

    useEffect(() => {
        const list = []
        const vesselCount = vessels.length;
        for (let i = 0; i < vesselCount; i++) {
            const { id, isPermission = true } = vessels[i] || {};
            const styleDays = {
                height: `calc(var(--${id}-height) + var(--more-height, 0px))`
            }
            list.push(<div key={i} className={styles.days} style={styleDays} data-is-permission={isPermission}>
                {week.map((item) => <Day key={item} />)}
            </div>)
        }

        setDays(<div className={styles.vessels}>
            {list}
        </div>)
    }, [vesselHeight, vessels]);

    return <div className={styles.weeks} style={style}>
        {weeks.map(({ key, time }) => <Week key={key} id={key} time={time}>
            {days}
        </Week>)}
        <CurrentDay weeks={weeks} />
    </div>;
};

export default Weeks;
